export const HOME = '/';
export const ADMIN_SETTINGS = '/admin-settings';
export const ACCOUNT_CENTER = '/account-centre';
export const GATHER_INFORMATION = '/auth/gather-information';

export const ADMIN_PERMISSION_ID = 'ADMN';
export const SUPER_ADMIN_PERMISSION_ID = 'SADM';
export const APPROVER_PERMISSION_ID = 'APVR';
/** Organisation portal: org admins only (not consumer WebApp roles). */
export const ALL_USER_PERMISSION = [ADMIN_PERMISSION_ID];

export const PRIVATE_ROUTE_USER_TYPE_CONFIG = {
  [HOME]: ALL_USER_PERMISSION,
  [ADMIN_SETTINGS]: ALL_USER_PERMISSION,
  [ACCOUNT_CENTER]: ALL_USER_PERMISSION,
  [GATHER_INFORMATION]: ALL_USER_PERMISSION,
};
